import { gql } from "@apollo/client";

export const UPDATE_RFID = gql`
  mutation UpdateRfidAsset(
    $uid: String!
    $access_type: String!
    $reg_id: String!
    $is_active: Boolean
    $event_id: Int!
    $cash_balance: Int!
    $promo_balance: Int!
    $personnal_pin: String!
    $last_four_phone_numbers: String!
    $tokens_balance: jsonb!
    $notes: String!
    $last_updated_by: Int
  ) {
    update_rfid_assets(
      where: { event_id: { _eq: $event_id }, uid: { _eq: $uid } }
      _set: {
        access_type: $access_type
        cash_balance: $cash_balance
        is_active: $is_active
        last_four_phone_numbers: $last_four_phone_numbers
        personnal_pin: $personnal_pin
        promo_balance: $promo_balance
        reg_id: $reg_id
        tokens_balance: $tokens_balance
        notes: $notes
        last_updated_by: $last_updated_by
      }
    ) {
      returning {
        id
      }
    }
  }
`;

export const UPDATE_RFID_WITHOUT_PIN = gql`
  mutation UpdateRfidAsset(
    $uid: String!
    $access_type: String!
    $reg_id: String!
    $is_active: Boolean
    $event_id: Int!
    $cash_balance: Int!
    $promo_balance: Int!
    $tokens_balance: jsonb!
    $notes: String!
    $last_updated_by: Int
  ) {
    update_rfid_assets(
      where: { event_id: { _eq: $event_id }, uid: { _eq: $uid } }
      _set: {
        access_type: $access_type
        cash_balance: $cash_balance
        is_active: $is_active
        promo_balance: $promo_balance
        reg_id: $reg_id
        tokens_balance: $tokens_balance
        notes: $notes
        last_updated_by: $last_updated_by
      }
    ) {
      returning {
        id
      }
    }
  }
`;

export const UPDATE_RFID_TOKENS_ONLY = gql`
  mutation UpdateRfidTokens(
    $uid: String!
    $event_id: Int!
    $tokens_balance: jsonb!
  ) {
    update_rfid_assets(
      where: { event_id: { _eq: $event_id }, uid: { _eq: $uid } }
      _set: {
        tokens_balance: $tokens_balance
      }
    ) {
      returning {
        id
        uid
        tokens_balance
      }
    }
  }
`;

export const UPDATE_RFID_BALANCES = gql`
  mutation UpdateRfidBalances(
    $uid: String!
    $event_id: Int!
    $tokens_balance: jsonb!
    $cash_balance: Int!
    $promo_balance: Int!
  ) {
    update_rfid_assets(
      where: { event_id: { _eq: $event_id }, uid: { _eq: $uid } }
      _set: {
        tokens_balance: $tokens_balance
        cash_balance: $cash_balance
        promo_balance: $promo_balance
      }
    ) {
      returning {
        id
        uid
        tokens_balance
        cash_balance
        promo_balance
      }
    }
  }
`;

export const UPDATE_TRANSFER_STATUS = gql`
  mutation UpdateTransferStatus(
    $id: Int!
    $status: String!
  ) {
    update_cashless_asset_transfer_history(
      where: { id: { _eq: $id } }
      _set: {
        status: $status
      }
    ) {
      returning {
        id
        status
      }
    }
  }
`;

export const CREATE_RFID = gql`
  mutation CreateRfidAsset($input: rfid_assets_insert_input!) {
    insert_rfid_assets_one(object: $input) {
      id
      uid
      event_id
      access_type
      reg_id
      is_active
      cash_balance
      promo_balance
      tokens_balance
      notes
      last_four_phone_numbers
      personnal_pin
      attendee_id
    }
  }
`;

export const UPDATE_RFID_BY_ID = gql`
  mutation UpdateRfidAssetById(
    $id: Int!
    $uid: String!
    $access_type: String!
    $reg_id: String!
    $is_active: Boolean
    $event_id: Int!
    $cash_balance: Int!
    $promo_balance: Int!
    $personnal_pin: String!
    $last_four_phone_numbers: String!
    $tokens_balance: jsonb!
    $notes: String!
    $last_updated_by: Int
  ) {
    update_rfid_assets(
      where: { id: { _eq: $id } }
      _set: {
        uid: $uid
        access_type: $access_type
        cash_balance: $cash_balance
        is_active: $is_active
        event_id: $event_id
        last_four_phone_numbers: $last_four_phone_numbers
        personnal_pin: $personnal_pin
        promo_balance: $promo_balance
        reg_id: $reg_id
        tokens_balance: $tokens_balance
        notes: $notes
        last_updated_by: $last_updated_by
      }
    ) {
      returning {
        id
      }
    }
  }
`;

export const UPDATE_RFID_BY_ID_WITHOUT_PIN = gql`
  mutation UpdateRfidAssetByIdWithoutPin(
    $id: Int!
    $uid: String!
    $access_type: String!
    $reg_id: String!
    $is_active: Boolean
    $event_id: Int!
    $cash_balance: Int!
    $promo_balance: Int!
    $tokens_balance: jsonb!
    $notes: String!
    $last_updated_by: Int
  ) {
    update_rfid_assets(
      where: { id: { _eq: $id } }
      _set: {
        uid: $uid
        access_type: $access_type
        cash_balance: $cash_balance
        is_active: $is_active
        event_id: $event_id
        promo_balance: $promo_balance
        reg_id: $reg_id
        tokens_balance: $tokens_balance
        notes: $notes
        last_updated_by: $last_updated_by
      }
    ) {
      returning {
        id
      }
    }
  }
`;
